const counterClockWise = {
  data() {
    return {
      jejuCenterPoint:  { y: 33.378143, x: 126.534351 },
      udoCenterPoint:   { y: 33.505081, x: 126.955842 },
      bontoCenterPoint: { y: 36.761407, x: 128.062935 },

      jejuPoints: [
        // { y: 33.526264, x: 126.490155 },
        // { y: 33.560844, x: 126.643303 },
        // { y: 33.571549, x: 126.780087 },
        // { y: 33.562972, x: 126.829390 },
        // { y: 33.527573, x: 126.915580 },
        // { y: 33.456332, x: 126.956781 }, // 성산일출봉 
        // { y: 33.388509, x: 126.914855 },
        // { y: 33.297827, x: 126.830423 },
        // { y: 33.261763, x: 126.683503 },
        // { y: 33.233529, x: 126.597946 },
        // { y: 33.230174, x: 126.565433 },
        // { y: 33.221306, x: 126.473223 },
        // { y: 33.212807, x: 126.313154 },
        // { y: 33.182695, x: 126.294175 },
        // { y: 33.184828, x:  126.26396 },
        // { y: 33.282805, x: 126.154594 },
        // { y: 33.363322, x:  126.15794 },
        // { y: 33.442719, x: 126.257318 },
        // { y: 33.474744, x:  126.30730 },
        // { y: 33.528140, x: 126.490144 },

        { y: 33.318273, x: 126.120650 },
        { y: 33.494791, x: 126.293794 },
        { y: 33.609272, x: 126.887991 },
        { y: 33.463910, x: 126.973548 },
        { y: 33.294738, x: 126.840296 },
        { y: 33.175004, x: 126.273726 },
      ],

      udoPoints: [
        { y: 33.505723, x: 126.938342 },
        { y: 33.526935, x: 126.952278 },
        { y: 33.503283, x: 126.974332 },
        { y: 33.486402, x: 126.962114 }
      ],

      bontoPoints: [
        { y: 37.744630, x: 126.239319 },
        { y: 38.353599, x: 127.117470 },
        { y: 38.676931, x: 128.435929 },
        { y: 37.110567, x: 129.661360 },
        { y: 36.016606, x: 129.697882 },
        { y: 34.931441, x: 129.303311 },
        { y: 34.287455, x: 127.545263 },
        { y: 34.291570, x: 125.754651 },
        { y: 36.049770, x: 126.341187 },
        { y: 36.905276, x: 125.966241 },
        { y: 37.160775, x: 126.386429 }
      ]
    };
  },

  methods: {
    ccwLineCheck(p1, p2, cp1, cp2) {
      let isCross = false;

      let cp1Result = (p2.x - p1.x) * (cp1.y - p1.y) - (cp1.x - p1.x) * (p2.y - p1.y);
      let cp2Result = (p2.x - p1.x) * (cp2.y - p1.y) - (cp2.x - p1.x) * (p2.y - p1.y);

      let p1Result = (cp1.x - cp2.x) * (p1.y - cp2.y) - (p1.x - cp2.x) * (cp1.y - cp2.y);
      let p2Result = (cp1.x - cp2.x) * (p2.y - cp2.y) - (p2.x - cp2.x) * (cp1.y - cp2.y);

      if (cp1Result * cp2Result < 0 && p1Result * p2Result < 0) isCross = true
      
      return isCross;
    },

    lineArrCheck(pointArr, carPoint, centerPoint) {
      let isLineCross = false;
      let j = 0;

      for (let i = 0; i < pointArr.length; i++) {
        if (i == pointArr.length - 1) {
          j = 0;
        } else {
          j = i + 1;
        }

        if (this.ccwLineCheck(pointArr[i], pointArr[j], carPoint, centerPoint)) {
          isLineCross = true;
          break;
        }
      }

      return isLineCross;
    },

    carPointCheck(carPoint) {
      let isCross = false;

      let isJejuCross = false;
      let isUdoCross = false;
      let isBontoCross = false;

      isJejuCross = this.lineArrCheck(this.jejuPoints, carPoint, this.jejuCenterPoint);
      isUdoCross = this.lineArrCheck(this.udoPoints, carPoint, this.udoCenterPoint);
      isBontoCross = this.lineArrCheck(this.bontoPoints, carPoint, this.bontoCenterPoint);

      if (isJejuCross && isUdoCross && isBontoCross) {
        isCross = true;
      } else {
        isCross = false;
      }

      return isCross;
    }
  }
};

export default counterClockWise;
